import { useCallback, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import LandingJazzCashScreen from "./LandingJazzCashScreen";
import JazzCashFallbackScreen from "./JazzCashFallBackScreen";
import TagManager from "react-gtm-module";
import { Config } from "../constants/Config";
import { generateToken } from "../services/AuthService";
import Loader from "../components/loader";

const LandingJazzCashRoutes = () => {
  //initialize GTM
  const tagManagerArgs = {
    gtmId: Config.GTM_ID,
  };
  TagManager.initialize(tagManagerArgs);
  useEffect(() => {
    initalizeToken();
  }, []);
  console.log("landingjazzcash");
  const [isLoading, setLoading] = useState<boolean>(true);
  const GUEST_CREDENTIALS = {
    username: Config.GUEST_USERNAME,
    password: Config.GUEST_PASSWORD,
  };
  const initalizeToken = useCallback(async (): Promise<void> => {
    try {
      const data = await generateToken(GUEST_CREDENTIALS);
      if (data.jwttoken) {
        global.token = data.jwttoken;
      } else {
        console.log("Token generation failed");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("authenticateToken error :", error);
    }
  }, []);
  const RedirectToMainApp = () => {
    useEffect(() => {
      window.location.replace("/home");
    }, []);
    return <></>;
  };

  useEffect(() => {
    const tagManagerArgs = { gtmId: Config.GTM_ID };
    TagManager.initialize(tagManagerArgs);
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <Routes>
        <Route path="/landing" element={<LandingJazzCashScreen />} />
        <Route path="/jc" element={<JazzCashFallbackScreen />} />
        <Route path="/*" element={<RedirectToMainApp />} />
      </Routes>
    </>
  );
};

export default LandingJazzCashRoutes;
